// @flow
import { apiJSON } from '../../configs/api-generators.js';
import { setProgress, setMessages } from '../ui/ui.actions.js';

import { GET_INSTRUCTOR_INFO } from './schedule.consts.js';

import { extractMessages } from '../ui/ui.helpers.js';

import { INSTRUCTORS_SCHEDULE } from '../calendar/calendar.consts.js';

export function* getInstructorInfo(
  resourceID: string,
  locationID: string,
  organizationID: string
): Yield<*> {
  try {
    yield setProgress(true, GET_INSTRUCTOR_INFO);

    const { organization, URL } = yield s => s;

    const response = yield* apiJSON(`/org/${organization.unique}/resources/getInstructorInfo/`, {
      resourceID,
      organizationID
    });

    if (response.ok) {
      yield setProgress(false, GET_INSTRUCTOR_INFO);
      if (!response.data) {
        yield {
          type: GET_INSTRUCTOR_INFO,
          payload: {}
        };
        return setMessages(extractMessages(response, INSTRUCTORS_SCHEDULE));
      }
      return yield {
        type: GET_INSTRUCTOR_INFO,
        payload: {
          ...response.data,
          locationID: (URL.eventParams && URL.eventParams.location) || locationID
        }
      };
    }

    throw new Error(response.error.join('\n'));
  } catch (e) {
    yield setProgress(false, GET_INSTRUCTOR_INFO);
    return setMessages({
      type: 'error',
      text: e.message
    });
  }
}
